import { FaCampground, FaChartBar, FaMoneyBillWaveAlt, FaUsersCog, FaUserTie, FaTicketAlt, FaList } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import useWindowSize from "../hooks/useWindowSize";
import { MdMenuOpen } from "react-icons/md";
import WithAuthentication from "Authentication/AuthenticationContext";
import { URL_ID } from "constants/constants.js";

export default function ManagementSidebar() {
  const auth = useContext(WithAuthentication);
  function getButtonIcon(id: number): JSX.Element | undefined {
    switch (id) {
      case URL_ID.adminTourList.id:
        return <FaList className="fs-5"></FaList>;
      case URL_ID.adminCreateTour.id:
        return <FaCampground className="fs-18" />;
      case URL_ID.adminUserManagement.id:
        return <FaUsersCog className="fs-5" />;
      case URL_ID.adminUserReport.id:
        return <FaUserTie className="fs-5" />;
      case URL_ID.adminManagement.id:
        return <FaChartBar className="fs-18 " />;
      case URL_ID.adminFinancial.id:
        return <FaMoneyBillWaveAlt className="fs-5" />;
      case URL_ID.adminReservation.id:
        return <FaTicketAlt className="fs-5" />;
    }
  }
  function addExtraButtons(): JSX.Element[] {
    let buttonsJSX: JSX.Element[] = [];
    for (const key in URL_ID) {
      if (auth.userInfo.accessLevel.includes(URL_ID[key].id)) {
        buttonsJSX.push(
          <li className="nav-item d-lg-block d-sm-none">
            <Link to={URL_ID[key].route} exact className=" nav-link align-middle px-0">
              {getButtonIcon(URL_ID[key].id)}
              <span className="ms-1  d-sm-inline"> {URL_ID[key].name}</span>
            </Link>
          </li>
        );
      }
    }

    return buttonsJSX;
  }

  const [isOpen, setIsOpen] = useState(false);
  const { width }: { width: number | undefined } = useWindowSize();
  useEffect(() => {
    if (width && width > 992 && isOpen === false) {
      setIsOpen(true);
    }
    if (width && width < 992 && isOpen === true) {
      setIsOpen(false);
    }
  }, [width]);

  return (
    <>
      {width && width < 992 && (
        <button
          className="btn btn-mobile-menu mt-4"
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          <MdMenuOpen></MdMenuOpen>
        </button>
      )}

      {isOpen && (
        <div className={`my-2 d-block ${width && width < 992 && "mobile-sidebar"}`} style={{ width: "250px", position: "sticky", top: "100px", height: "404px" }}>
          {/* <div className="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
            <div className="input-group border border-black-50 rounded mx-auto mb-2">
              <input type="text" className="form-control border-0" placeholder="جستجو" style={{ backgroundColor: "#e9f6f5" }} aria-label="Input group example" aria-describedby="btnGroupAddon" />
              <button className="input-group-text border-0" id="btnGroupAddon" style={{ backgroundColor: "#e9f6f5" }}>
                <FaSearch />
              </button>
            </div>
          </div> */}
          <ul className="menu1 nav nav-pills flex-column mb-sm-auto mb-0 align-items-sm-start px-2 border border-black-50" style={{ backgroundColor: "#e9f6f5" }} id="menu">
            {addExtraButtons()}
          </ul>
        </div>
      )}
    </>
  );
}
